import { useState } from 'react';
import { CircularProgress, styled } from '@mui/material';
import SettingsModal from '../Modal/settingsCustomModal';
import { ReactComponent as RouteIcon } from '../../../../svg/adminRoleIcon.svg';
import ViewRouteContent from './ViewRouteContent';
import ViewContent from './ViewContent';
import EditRouteContent from './EditRouteContent';
import DeleteRouteContent from './DeleteRouteContent';
import apiCall from '../../../../utils/apiCall';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

interface Routes {
    RouteName: string;
    RouteId: number;
    Status: boolean;
};

interface RouteData {
    Data: Routes[];
};

// interface RoutesResponse {
//     data: RouteData;
// };

interface ButtonProp{
    handleClick: () => void;
}
// export const membershipRouteData = [
//     {
//         icon: <RouteIcon />,
//         routeText: "Examination/NYSC",
//         statusText: "Active",
//         date: "Created March 23, 2023"
//     },
//     {
//         icon: <RouteIcon />,
//         routeText: "Practitioner Admin",
//         statusText: "Disabled",
//         date: "Created March 23, 2023"   
//     },
//     {
//         icon: <RouteIcon />,
//         routeText: "Executive Admin",
//         statusText: "Disabled",
//         date: "Created March 23, 2023"
//     },
//     {
//         icon: <RouteIcon />,
//         routeText: "Academic Admin",
//         statusText: "Disabled",
//         date: "Created March 23, 2023"
//     },
//     {
//         icon: <RouteIcon />,
//         routeText: "Military Admin",
//         statusText: "Disabled",
//         date: "Created March 23, 2023"
//     },
//     {
//         icon: <RouteIcon />,
//         routeText: "Corporate Admin",
//         statusText: "Disabled",
//         date: "Created March 23, 2023"
//     },
//     {
//         icon: <RouteIcon />,
//         routeText: "Finance Officer",
//         statusText: "Active",
//         date: "Created March 23, 2023"
//     }
// ]

const MembershipRouteContent = () => {
    const [openRouteModal, setOpenRouteModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [routeName, setRouteName] = useState('');
    const [routeStatus, setRouteStatus] = useState(false);
    const [routeId, setRouteId] = useState(0);

    const handleOpenRouteModal = () => setOpenRouteModal(true);
    const handleCloseRouteModal = () => setOpenRouteModal(false)

    const handleOpenEditModal = () => setOpenEditModal(true);
    const handleCloseEditModal = () => setOpenEditModal(false);

    const handleOpenDeleteModal = () => setOpenDeleteModal(true);
    const handleCloseDeleteModal = () => setOpenDeleteModal(false)

    const getAllRoutes = async (): Promise<RouteData> => {
        return (await apiCall().get('/Routes/GetAllRoute')).data
    };

    const { data, isLoading, error, isError } = useQuery(['get-all-routes'], getAllRoutes, {
        retry: 0,
        keepPreviousData: true,
        enabled: true,
    });
    
    const routeData = data?.Data;
    const getAllRoutesError = error as AxiosError;
    const getAllRoutesErrorMessage = getAllRoutesError?.message;

    const handleEdit = () => {
        handleCloseRouteModal();
        handleOpenEditModal();
    }
    
    const handleDelete = () => {
        handleCloseRouteModal();
        handleOpenDeleteModal();
    }

    const handleOpen = (route: Routes) => {
        setRouteName(route?.RouteName);
        setRouteStatus(route?.Status);
        setRouteId(route?.RouteId)
        handleOpenRouteModal();
    }

  return (
    <StyledContainer>
        {isLoading ? (
            <CircularProgress 
                sx={{
                    display: 'block',
                    marginInline: 'auto',
                    marginBlock: '2rem',
                    fontSize: '1rem',
                }}
            />
        ) : isError ? 
        (
            <StyledError>{getAllRoutesErrorMessage}</StyledError>
        ) : (
            <>
                <TotalWrapper>
                    <span>Total</span>
                    <TotalNumberStyle>{routeData?.length}</TotalNumberStyle>
                </TotalWrapper>
                {
                    routeData && 
                    routeData?.length > 0 ?
                    routeData?.map((data: Routes, index:number) =>
                        <RoleWrapper onClick={() => handleOpen(data)} key={index}>
                            <div>
                                <RoleIconWrapper><RouteIcon /></RoleIconWrapper>
                                <RoleText>{data?.RouteName}</RoleText>
                                {data?.Status === true ? <Active>Active</Active> : <Disabled>Disabled</Disabled>}
                                <DateWrapper>Created</DateWrapper>
                            </div>
                        </RoleWrapper>
                    ) : ""
                }
            </>
        )}

        <SettingsModal 
            open={openRouteModal}
            cancel={handleCloseRouteModal}
            maxWidth={'712px'}
            header={routeName}
            content={<ViewRouteContent status={routeStatus}/>}
            card ={<ViewContent handleEdit={handleEdit} handleDelete={handleDelete}/>}
        />

        <SettingsModal
            open={openEditModal}
            cancel={handleCloseEditModal}
            maxWidth='480px'
            header='Edit Route'
            showrightIcon={false}
            content={<EditRouteContent handleClose={handleCloseEditModal} id={routeId} routeName={routeName}/>}   
        />

        <SettingsModal
            open={openDeleteModal}
            cancel={handleCloseDeleteModal}
            maxWidth='536px'
            header='Delete Route'
            showrightIcon={false}
            content={<DeleteRouteContent handleClose={handleCloseDeleteModal} id={routeId} routeName={routeName}/>}   
      />
    </StyledContainer>
  )
}

export default MembershipRouteContent;

const StyledContainer = styled('div')`
    margin-block: 3.8rem;
    margin-inline: 3.5rem;
`
const TotalWrapper = styled('div')`
    color: #4E5A62;
    font-weight: 500;
`
const TotalNumberStyle = styled('span')`
    background-color: #F1F3F4;
    border-radius: 0.2rem;
    margin-inline-start: 0.4rem;
    padding-inline: 0.2rem;
`
const RoleWrapper = styled('div')`
    display: flex;
    justify-content: space-between;
    border: 0.1rem solid #E1E1E1;
    margin-block: 0.6rem;
    padding-inline: 1.2rem;
    padding-block: 1.2rem;
    border-radius: 0.5rem;
    width: 100%;
    text-align: left;
    background-color: transparent;
`

const RoleIconWrapper = styled('span')`
    background-color: #FFF4DE;
    border-radius: 0.1rem;
    padding-inline: 0.4rem;
`

const RoleText = styled('span')`
    font-weight: 600;
    font-size: 16px;
    margin-inline: 0.8rem;
`

const Active = styled('span')`
    font-size: 14px;
    font-weight: 500;
    background-color: #E0FAEE;
    border-radius: 0.4rem;
    padding-inline: 0.5rem;
    color: #11643C;
`

const DateWrapper = styled('div')`
    margin-block-start: 0.8rem;
    font-size: 14px;
`

const ArrowIconWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    justify-content: center;
`

const Disabled = styled('span')`
    font-size: 1rem;
    font-weight: 500;
    background-color: #FAE0E0;
    border-radius: 0.4rem;
    padding-inline: 0.5rem;
    color: #DD5151;
`

const StyledError = styled('p')`
  color: red;
  font-size: 1.4rem;
  display: flex;
`